/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
export type GetLicenseKeyApiV1AppsumoLicenseKeyGetGetParams = {
  code: string
}

export type GetSubscriptionPlansApiV1SubscriptionsPlansGetParams = {
  type?: string
}

export type GetStatisticsApiV1StatisticsGetParams = {
  date_from?: string
  date_to?: string
  vacancy_ids?: string[]
}

export type PaddleWebhookApiV1PaymentsPaddlePostBody = {
  [key: string]: unknown
}

export type ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetOrder =
  (typeof ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetOrder)[keyof typeof ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetOrder =
  {
    asc: 'asc',
    desc: 'desc'
  } as const

export type ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetParams =
  {
    limit?: number
    offset?: number
    company_id?: string
    transaction_type?: InterviewTransactionType
    order_by?: string
    order?: ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetOrder
    date_from?: string
    date_to?: string
  }

export type GetListApiV1EmployersGetParams = {
  limit?: number
  offset?: number
  company_id?: string
  search?: string
}

export type LivenessV1StatusLivenessGet200 = { [key: string]: string }

export type LivenessV1StatusReadinessGet200 = { [key: string]: string }

export type ListNotificationEmailsApiV1NotificationsEmailsGetParams = {
  limit?: number
  offset?: number
  company_id?: string
}

export type ListCompaniesApiV1CompaniesGetParams = {
  limit?: number
  offset?: number
  search?: string
}

export type ListVacanciesApiV1VacanciesGetParams = {
  limit?: number
  offset?: number
  company_id?: string
}

export type GetInterviewStateApiV1InterviewsStateGetParams = {
  vacancy_id: string
}

export type ListInterviewsApiV1InterviewsResultsGetOrder =
  (typeof ListInterviewsApiV1InterviewsResultsGetOrder)[keyof typeof ListInterviewsApiV1InterviewsResultsGetOrder]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListInterviewsApiV1InterviewsResultsGetOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type ListInterviewsApiV1InterviewsResultsGetOrderBy =
  (typeof ListInterviewsApiV1InterviewsResultsGetOrderBy)[keyof typeof ListInterviewsApiV1InterviewsResultsGetOrderBy]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListInterviewsApiV1InterviewsResultsGetOrderBy = {
  date: 'date',
  created_at: 'created_at',
  updated_at: 'updated_at',
  overall_score: 'overall_score',
  grade: 'grade',
  name: 'name'
} as const

export type ListInterviewsApiV1InterviewsResultsGetParams = {
  limit?: number
  offset?: number
  vacancy_id?: string
  is_relevant?: boolean
  is_marked?: boolean
  is_deleted?: boolean
  order_by?: ListInterviewsApiV1InterviewsResultsGetOrderBy
  order?: ListInterviewsApiV1InterviewsResultsGetOrder
  date_from?: string
  date_to?: string
}

export type ListPushDeliveriesApiV1PushDeliveriesGetParams = {
  limit?: number
  offset?: number
}

export type GetHistoryApiV1HistoryArtificIdMessagesGetParams = {
  limit?: number
  offset?: number
  message_id?: string
}

export type ListCheckoutItemsApiV1CheckoutsListItemsGetParams = {
  limit?: number
  offset?: number
}

export type ListArtificsApiV1ExpertsGetParams = {
  limit?: number
  offset?: number
  with_disabled?: boolean
  search?: string
}

export type GetProfileApiV1UsersSelfProfileGetParams = {
  user_id: string
}

export type ListUsersApiV1UsersGetParams = {
  limit?: number
  offset?: number
}

export type SrcDomainsVacancySchemasGetVoicesResponseMeta = {
  [key: string]: unknown
}

export type SrcDomainsVacancySchemasGetVoicesResponseError = {
  [key: string]: unknown
}

export interface SrcDomainsVacancySchemasGetVoicesResponse {
  data: VacancyVoiceParamsResource[]
  error: SrcDomainsVacancySchemasGetVoicesResponseError
  meta: SrcDomainsVacancySchemasGetVoicesResponseMeta
}

export interface SrcDomainsStatisticsSchemasGetStatisticsResponseData {
  external_statistics: ExternalStatistics
  internal_statistics: InternalStatistics
}

export interface SrcDomainsInterviewSchemasGetInterviewStateResponseData {
  interview: InterviewResource
  messages: MessageResource[]
  presentation_slides_urls?: string[]
}

export interface SrcDomainsArtificSchemasGetVoicesResponse {
  data: ArtificVoiceParams[]
}

export interface VideoAvatarResource {
  external_id: string
  id: string
  is_enabled: boolean
  preview?: FileResource
}

export interface ValidationRule {
  equals?: unknown
  error_message?: string
  gte?: unknown
  lte?: unknown
  regex?: string
  required?: boolean
}

export type ValidationErrorLocItem = string | number

export interface ValidationError {
  loc: ValidationErrorLocItem[]
  msg: string
  type: string
}

export interface VacancyVoiceParamsResource {
  generator: string
  parameters: ElevenLabsVoiceParams
  [key: string]: unknown
}

export interface VacancyUpdateRequest {
  camera_required?: boolean
  company_id?: string
  company_pic_file_id?: string
  description?: string
  desktop_meeting_mode?: VacancyMeetingMode
  employer_id?: string
  expert_id?: string
  full_description?: string
  mobile_meeting_mode?: VacancyMeetingMode
  overridden_company_title?: string
  success_threshold?: number
  system_prompt_instructions?: string[]
  title?: string
  user_prompt_instructions?: string[]
  video_avatar_id?: string
  welcome_phrase?: string
  [key: string]: unknown
}

export interface VacancyUISettingsCollectionResource {
  settings: VacancyDefaultUISettingsResource[]
}

export interface VacancySimplifiedResource {
  created_at: string
  description: string
  desktop_meeting_mode: VacancyMeetingMode
  employer?: EmployerResource
  id: string
  mobile_meeting_mode: VacancyMeetingMode
  overridden_company_title?: string
  title: string
  updated_at: string
  [key: string]: unknown
}

export interface VacancyResource {
  alias?: string
  camera_required: boolean
  candidates_count: number
  company: SimplifiedCompanyResource
  /**
   * Deprecated in favor or company field
   * @deprecated
   */
  company_id: string
  company_logo?: FileResource
  /**
   * Deprecated in favor or company_logo field
   * @deprecated
   */
  company_pic_file_url?: string
  created_at: string
  description: string
  desktop_meeting_mode: VacancyMeetingMode
  employer?: EmployerResource
  full_description: string
  id: string
  interview_url?: string
  interviewer?: SimplifiedArtificResource
  is_ready_for_interview: boolean
  language?: LanguageCode
  meeting_mode?: VacancyMeetingMode
  mobile_meeting_mode: VacancyMeetingMode
  overridden_company_title?: string
  secondary_language?: LanguageCode
  success_threshold: number
  system_prompt_instructions?: string[]
  title: string
  updated_at: string
  user_prompt_instructions?: string[]
  video_avatar?: VideoAvatarResource
  welcome_phrase?: string
  [key: string]: unknown
}

export interface VacancyRedFlagStoreSchema {
  description: string
  id?: string
  title: string
}

export interface VacancyRedFlagStoreRequest {
  red_flags: VacancyRedFlagStoreSchema[]
}

export interface VacancyRedFlagResource {
  description: string
  id: string
  title: string
}

export type VacancyMeetingMode =
  (typeof VacancyMeetingMode)[keyof typeof VacancyMeetingMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VacancyMeetingMode = {
  chat_only: 'chat_only',
  voice_only: 'voice_only',
  voice_and_video: 'voice_and_video'
} as const

export type VacancyInferenceSettingsUpdateRequestGenerationParams = {
  [key: string]: unknown
}

export interface VacancyInferenceSettingsUpdateRequest {
  generation_params?: VacancyInferenceSettingsUpdateRequestGenerationParams
  inference_type?: InferenceType
}

export type VacancyInferenceSettingsResourceGenerationParams = {
  [key: string]: unknown
}

export interface VacancyInferenceSettingsResource {
  generation_params: VacancyInferenceSettingsResourceGenerationParams
  id: string
  inference_type: InferenceType
}

export interface VacancyDefaultUIWelcomeScreen {
  bubble_messages: VacancyDefaultUIBubbleMessage[]
  header1: string
  header2: string
  header3: string
  phone_country_code?: string
}

export interface VacancyDefaultUIResultsScreen {
  bubble_messages_fail: VacancyDefaultUIBubbleMessage[]
  bubble_messages_success: VacancyDefaultUIBubbleMessage[]
  header: string
}

export interface VacancyDefaultUISettings {
  footer: VacancyDefaultUIFooter
  results_screen: VacancyDefaultUIResultsScreen
  type?: string
  welcome_screen: VacancyDefaultUIWelcomeScreen
}

export interface VacancyDefaultUIFooterTimelineItem {
  duration: string
  title: string
}

export interface VacancyDefaultUIFooterTimeline {
  items: VacancyDefaultUIFooterTimelineItem[]
}

export interface VacancyDefaultUIFooter {
  timeline: VacancyDefaultUIFooterTimeline
}

export interface VacancyDefaultUISettingsResource {
  footer: VacancyDefaultUIFooter
  results_screen: VacancyDefaultUIResultsScreen
  type?: string
  vacancy_id?: string
  welcome_screen: VacancyDefaultUIWelcomeScreen
}

export type VacancyDefaultUIBubbleType =
  (typeof VacancyDefaultUIBubbleType)[keyof typeof VacancyDefaultUIBubbleType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VacancyDefaultUIBubbleType = {
  message: 'message',
  html_message: 'html_message',
  button: 'button',
  link: 'link',
  form_email: 'form_email',
  form_phone: 'form_phone',
  form_email_phone: 'form_email_phone',
  form_email_phone_contact: 'form_email_phone_contact',
  custom_form: 'custom_form'
} as const

export type VacancyDefaultUIBubbleMessageType =
  (typeof VacancyDefaultUIBubbleMessageType)[keyof typeof VacancyDefaultUIBubbleMessageType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VacancyDefaultUIBubbleMessageType = {
  incoming: 'incoming',
  outgoing: 'outgoing'
} as const

export interface VacancyDefaultUIBubbleMessage {
  form_schema?: FormSchema
  is_link_internal?: boolean
  link?: string
  message_type: VacancyDefaultUIBubbleMessageType
  text?: string
  type: VacancyDefaultUIBubbleType
}

export interface VacancyCriteriaStoreSchema {
  description: string
  evaluation_result_weight: number
  id?: string
  pos: number
  questions: string[]
  title: string
}

export interface VacancyCriteriaStoreRequest {
  criterias: VacancyCriteriaStoreSchema[]
}

export interface VacancyCriteriaResource {
  description: string
  evaluation_result_weight: number
  id: string
  pos: number
  questions: string[]
  title: string
}

export interface VacancyCreateRequest {
  camera_required?: boolean
  company_id: string
  description: string
  desktop_meeting_mode?: VacancyMeetingMode
  employer_id?: string
  expert_id?: string
  full_description?: string
  mobile_meeting_mode?: VacancyMeetingMode
  overridden_company_title?: string
  success_threshold?: number
  system_prompt_instructions?: string[]
  title: string
  user_prompt_instructions?: string[]
  welcome_phrase?: string
  [key: string]: unknown
}

export interface UserUpdate {
  email?: string
  firebase_push_token?: string
  is_active?: boolean
  is_superuser?: boolean
  is_verified?: boolean
  last_visited_at?: string
  password?: string
}

export interface UserSubscription {
  /** User subscription */
  subscription?: Subscription
  /** Subscription exists */
  success?: boolean
}

export type UserSegment = (typeof UserSegment)[keyof typeof UserSegment]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSegment = {
  all: 'all',
  signed_in_1_day_ago: 'signed_in_1_day_ago',
  signed_in_3_days_ago: 'signed_in_3_days_ago',
  signed_in_7_days_ago: 'signed_in_7_days_ago',
  signed_up_4_hours_ago: 'signed_up_4_hours_ago'
} as const

export type UserResponseMeta = { [key: string]: unknown }

export type UserResponseError = { [key: string]: unknown }

export interface UserResource {
  appsumo?: AppsumoResource
  company_id?: string
  email: string
  firebase_uid?: string
  id: string
  is_active: boolean
  is_anonymous: boolean
  is_paid_user?: boolean
  is_superuser: boolean
  is_verified: boolean
  paddle_customer_id?: string
}

export interface UserResponse {
  data: UserResource
  error: UserResponseError
  meta: UserResponseMeta
}

export type UserId = string

export interface UserRead {
  email: string
  id: UserId
  is_active?: boolean
  is_superuser?: boolean
  is_verified?: boolean
}

export type UserDevice = (typeof UserDevice)[keyof typeof UserDevice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserDevice = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop'
} as const

export interface UserCreate {
  email: string
  is_active?: boolean
  is_anonymous?: boolean
  is_superuser?: boolean
  is_verified?: boolean
  password: string
}

export interface UseLicenseKeyRequest {
  license_key: string
}

export type UpdateVacancyUISettingsResponseMeta = { [key: string]: unknown }

export type UpdateVacancyUISettingsResponseError = { [key: string]: unknown }

export interface UpdateVacancyUISettingsResponse {
  data: VacancyDefaultUISettings
  error: UpdateVacancyUISettingsResponseError
  meta: UpdateVacancyUISettingsResponseMeta
}

export interface UpdateVacancyUISettingsRequest {
  footer: VacancyDefaultUIFooter
  results_screen: VacancyDefaultUIResultsScreen
  type?: string
  welcome_screen: VacancyDefaultUIWelcomeScreen
}

export type UpdateVacancyCriteriaResponseMeta = { [key: string]: unknown }

export type UpdateVacancyCriteriaResponseError = { [key: string]: unknown }

export interface UpdateVacancyCriteriaResponse {
  data: VacancyCriteriaResource[]
  error: UpdateVacancyCriteriaResponseError
  meta: UpdateVacancyCriteriaResponseMeta
}

export interface UpdateReferenceRequest {
  description?: string
  sort?: number
  title: string
  value?: string
}

export interface UpdateProfileRequest {
  contact_email?: string
  contact_phone?: string
  name?: string
  profile_pic_id?: string
  second_name?: string
}

export interface UpdateNotificationEmailRequest {
  company_id?: string
  email?: string
  enabled?: boolean
  notification_types?: NotificationTypes
  title?: string
}

export interface UpdateMessageRequest {
  message: string
}

export interface UpdateInterviewRequest {
  candidate_additional_contact?: string
  candidate_contact_email?: string
  candidate_contact_phone?: string
  candidate_name?: string
  candidate_second_name?: string
  duration_seconds?: number
  hg_session_id?: string
  is_marked?: boolean
  meeting_mode?: VacancyMeetingMode
  reason?: string
}

export interface UpdateEvaluationTemplateRequest {
  system_prompt_instructions?: string[]
  user_prompt_instructions?: string[]
}

export interface UpdateCompanyRequest {
  description?: string
  is_deleted?: boolean
  name?: string
}

export type UpdateArtificRequestGenerationParams = {
  [key: string]: BaseGenerationParams
}

export interface UpdateArtificRequest {
  avatar?: ArtificAvatarParams
  avatar_type?: AvatarType
  elevenlabs_voice_id?: string
  full_description?: string
  full_name?: string
  gender?: Gender
  generation_params?: UpdateArtificRequestGenerationParams
  inference_type?: InferenceType
  is_enabled?: boolean
  profile_pic_file_id?: string
  voice?: ArtificVoiceParams
}

export interface UnitPrice {
  amount: string
  currency_code: string
}

export interface SumbitFormsRequest {
  forms?: SubmittedForm[]
}

/**
 * Additional error context
 */
export type SubscriptionErrorResponseDetails = { [key: string]: unknown }

/**
 * Standardized error response format
 */
export interface SubscriptionErrorResponse {
  /** Additional error context */
  details?: SubscriptionErrorResponseDetails
  /** Error type identifier */
  error: string
  /** Human-readable error message */
  message: string
  /** Seconds to wait before retry */
  retry_after?: number
  success?: boolean
}

export type SubscriptionStatus =
  (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionStatus = {
  active: 'active',
  paused: 'paused',
  canceled: 'canceled',
  past_due: 'past_due',
  trialing: 'trialing'
} as const

export type SubscriptionCollectionMode =
  (typeof SubscriptionCollectionMode)[keyof typeof SubscriptionCollectionMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionCollectionMode = {
  automatic: 'automatic',
  manual: 'manual'
} as const

export interface Subscription {
  address_id: string
  billing_cycle: BillingCycle
  billing_details: BillingDetails
  business_id: string
  canceled_at: string
  collection_mode: SubscriptionCollectionMode
  created_at: string
  currency_code: string
  current_billing_period: BillingPeriod
  custom_data: unknown
  customer_id: string
  discount: unknown
  first_billed_at: string
  id: string
  import_meta: unknown
  items: Item[]
  management_urls: ManagementUrls
  next_billed_at: string
  paused_at: string
  scheduled_change: unknown
  started_at: string
  status: SubscriptionStatus
  updated_at: string
}

export type SubmittedFormData = { [key: string]: unknown }

export interface SubmittedForm {
  data: SubmittedFormData
  error_message?: string
  is_failed?: boolean
}

export interface SubmitGenerationRequest {
  generation_id: string
  interview_id?: string
  user_id: UserId
  vacancy_id?: string
}

export type StringOrNoneResponseMeta = { [key: string]: unknown }

export type StringOrNoneResponseError = { [key: string]: unknown }

export interface StringOrNoneResponse {
  data: string
  error: StringOrNoneResponseError
  meta: StringOrNoneResponseMeta
}

export type StoreVacancyRedFlagResponseMeta = { [key: string]: unknown }

export type StoreVacancyRedFlagResponseError = { [key: string]: unknown }

export interface StoreVacancyRedFlagResponse {
  data: VacancyRedFlagResource[]
  error: StoreVacancyRedFlagResponseError
  meta: StoreVacancyRedFlagResponseMeta
}

export interface StoreNotificationEmailsRequest {
  company_id: string
  emails: NotificationEmailToStore[]
}

export interface SimplifiedCompanyResource {
  id: string
  name: string
}

export interface SimplifiedArtificResource {
  avatar_id: string
  avatar_type: AvatarType
  full_name: string
  gender: Gender
  id: string
  language: LanguageCode
  profile_pic?: FileResource
  voice_id: string
  voice_velocity: number
}

export type SendSinglePushRequestData = { [key: string]: string }

export interface SendSinglePushRequest {
  data?: SendSinglePushRequestData
  image?: string
  text: string
  title: string
  user_id: UserId
  [key: string]: unknown
}

export type ReferenceType = (typeof ReferenceType)[keyof typeof ReferenceType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferenceType = {
  interests: 'interests',
  scenarios: 'scenarios',
  ages: 'ages',
  pronounces: 'pronounces',
  tags: 'tags',
  navigation_tabs: 'navigation_tabs',
  instructions_templates: 'instructions_templates',
  suggestions_prompt_templates: 'suggestions_prompt_templates'
} as const

export interface ReferenceResource {
  alias: string
  description?: string
  sort: number
  title: string
  type: string
  value: string
}

export interface QuizAttachment {
  options: string[]
  question: string
  type: string
}

export interface QuestStatusAttachment {
  avatar: FileResource
  quest_status_string: string
  text: string
  title: string
  type: string
}

export interface QuestScoreAttachment {
  rounds_played: number
  rounds_total: number
  score_per_round: number
  score_total: number
  type: string
}

export interface Quantity {
  maximum: number
  minimum: number
}

export type PushContentResourceAdditionalData = { [key: string]: unknown }

export interface PushContentResource {
  additional_data?: PushContentResourceAdditionalData
  artific?: SimplifiedArtificResource
  artific_id?: string
  text: string
  title: string
  use_with_any_artific?: boolean
  [key: string]: unknown
}

export interface PushDeliveryUpdate {
  contents?: PushContentResource[]
  description?: string
  dry_run?: boolean
  is_enabled?: boolean
  title?: string
  user_segment?: UserSegment
  [key: string]: unknown
}

export interface PushDeliveryResource {
  contents: PushContentResource[]
  created_at: string
  description?: string
  dry_run: boolean
  id: string
  is_enabled: boolean
  title: string
  user_segment: UserSegment
  [key: string]: unknown
}

export interface PushDeliveryCreate {
  contents: PushContentResource[]
  description?: string
  dry_run: boolean
  is_enabled: boolean
  title: string
  user_segment: UserSegment
  [key: string]: unknown
}

export interface ProfileResource {
  balance: number
  contact_email?: string
  contact_phone?: string
  name: string
  profile_pic?: FileResource
  second_name?: string
  user_id: UserId
}

export interface Product {
  created_at: string
  custom_data: CustomData
  description: string
  id: string
  image_url: string
  name: string
  status: string
  type: string
  updated_at: string
}

export interface Price {
  billing_cycle: BillingCycle
  created_at: string
  custom_data: CustomData
  description: string
  id: string
  import_meta: unknown
  name: string
  product_id: string
  quantity: Quantity
  status: string
  tax_mode: string
  trial_period: BillingCycle
  type: string
  unit_price: UnitPrice
  updated_at: string
}

/**
 * Subscription plans list response
 */
export interface PlansListResponse {
  plans: PlanList
  success?: boolean
}

export interface PlansByProduct {
  chat: Price[]
  video_voice_chat: Price[]
  voice_chat: Price[]
}

export interface PlanList {
  month: PlansByProduct
  year: PlansByProduct
}

export interface OnboardingData {
  ages: string
  interests: LegacyOnboardingInterest[]
  pronounce: string
  scenarios: string[]
}

export interface NotificationTypes {
  finished_interview?: boolean
  unfinished_interview?: boolean
}

export interface NotificationEmailToStore {
  email: string
  enabled: boolean
  id?: string
  notification_types?: NotificationTypes
  title: string
}

export type NotificationEmailResourceNotificationTypes = {
  [key: string]: unknown
}

export interface NotificationEmailResource {
  company_id: string
  created_at: string
  email: string
  enabled: boolean
  id: string
  is_confirmed: boolean
  notification_types: NotificationEmailResourceNotificationTypes
  title: string
  updated_at: string
}

export type MessageResponseMeta = { [key: string]: unknown }

export type MessageResponseError = { [key: string]: unknown }

export interface MessageResponse {
  data: MessageResource
  error: MessageResponseError
  meta: MessageResponseMeta
}

export type MessageResourceAttachmentsItem =
  | ImageAttachment
  | ArtificAttachment
  | QuestStatusAttachment
  | QuestScoreAttachment
  | QuizAttachment
  | AivyInterviewStatusAttachment
  | AivyVideoRecordAgreement
  | AivyInterviewSwitchLanguageAttachment
  | AivyGenerationIdAttachment

export interface MessageResource {
  artific_id: string
  attachments: MessageResourceAttachmentsItem[]
  created_at: string
  generated_by: InferenceType
  id: string
  message: string
  role: string
  updated_at: string
  user_id: UserId
}

export interface MarkServiceErrorRequest {
  reason: string
}

export interface ManagementUrls {
  cancel: string
  update_payment_method: string
}

export type ListVacancyRedFlagResponseMeta = { [key: string]: unknown }

export type ListVacancyRedFlagResponseError = { [key: string]: unknown }

export interface ListVacancyRedFlagResponse {
  data: VacancyRedFlagResource[]
  error: ListVacancyRedFlagResponseError
  meta: ListVacancyRedFlagResponseMeta
}

export type ListVacancyCriteriaResponseMeta = { [key: string]: unknown }

export type ListVacancyCriteriaResponseError = { [key: string]: unknown }

export interface ListVacancyCriteriaResponse {
  data: VacancyCriteriaResource[]
  error: ListVacancyCriteriaResponseError
  meta: ListVacancyCriteriaResponseMeta
}

export type ListVacanciesResponseMeta = { [key: string]: unknown }

export type ListVacanciesResponseError = { [key: string]: unknown }

export interface ListVacanciesResponse {
  data: VacancyResource[]
  error: ListVacanciesResponseError
  meta: ListVacanciesResponseMeta
}

export type ListUsersResponseMeta = { [key: string]: unknown }

export type ListUsersResponseError = { [key: string]: unknown }

export interface ListUsersResponse {
  data: UserResource[]
  error: ListUsersResponseError
  meta: ListUsersResponseMeta
}

export type ListReferenceResponseMeta = { [key: string]: unknown }

export type ListReferenceResponseError = { [key: string]: unknown }

export interface ListReferenceResponse {
  data: ReferenceResource[]
  error: ListReferenceResponseError
  meta: ListReferenceResponseMeta
}

export type ListPushDeliveriesResponseMeta = { [key: string]: unknown }

export type ListPushDeliveriesResponseError = { [key: string]: unknown }

export interface ListPushDeliveriesResponse {
  data: PushDeliveryResource[]
  error: ListPushDeliveriesResponseError
  meta: ListPushDeliveriesResponseMeta
}

export interface ListNotificationEmailsResponse {
  data: NotificationEmailResource[]
}

export type ListMessagesResponseMeta = { [key: string]: unknown }

export type ListMessagesResponseError = { [key: string]: unknown }

export interface ListMessagesResponse {
  data: MessageResource[]
  error: ListMessagesResponseError
  meta: ListMessagesResponseMeta
}

export type ListInterviewTransactionsResponseMeta = { [key: string]: unknown }

export type ListInterviewTransactionsResponseError = { [key: string]: unknown }

export interface ListInterviewTransactionsResponse {
  data: InterviewTransactionResource[]
  error: ListInterviewTransactionsResponseError
  meta: ListInterviewTransactionsResponseMeta
}

export type ListInterviewResultsResponseMeta = { [key: string]: unknown }

export type ListInterviewResultsResponseError = { [key: string]: unknown }

export interface ListInterviewResultsResponse {
  data: InterviewResultsResource[]
  error: ListInterviewResultsResponseError
  meta: ListInterviewResultsResponseMeta
}

export type ListExpertsResponseMeta = { [key: string]: unknown }

export type ListExpertsResponseError = { [key: string]: unknown }

export interface ListExpertsResponse {
  data: ExpertResource[]
  error: ListExpertsResponseError
  meta: ListExpertsResponseMeta
}

export type ListEmployersResponseMeta = { [key: string]: unknown }

export type ListEmployersResponseError = { [key: string]: unknown }

export interface ListEmployersResponse {
  data: EmployerResource[]
  error: ListEmployersResponseError
  meta: ListEmployersResponseMeta
}

export type ListCompaniesResponseMeta = { [key: string]: unknown }

export type ListCompaniesResponseError = { [key: string]: unknown }

export interface ListCompaniesResponse {
  data: CompanyResource[]
  error: ListCompaniesResponseError
  meta: ListCompaniesResponseMeta
}

export type ListCheckoutItemsResponseMeta = { [key: string]: unknown }

export type ListCheckoutItemsResponseError = { [key: string]: unknown }

export interface ListCheckoutItemsResponse {
  data: CheckoutItemResource[]
  error: ListCheckoutItemsResponseError
  meta: ListCheckoutItemsResponseMeta
}

export type LicenseStatus = (typeof LicenseStatus)[keyof typeof LicenseStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicenseStatus = {
  active: 'active',
  inactive: 'inactive',
  deactivated: 'deactivated'
} as const

export interface LicenseResponse {
  license_key: string
  scopes: string[]
  status: string
}

export interface LicenseExtra {
  reason?: string
}

export interface LegacyOnboardingInterest {
  name: string
  values: string[]
}

export type LanguageCode = (typeof LanguageCode)[keyof typeof LanguageCode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LanguageCode = {
  en: 'en',
  ru: 'ru',
  es: 'es',
  tr: 'tr',
  pl: 'pl',
  it: 'it',
  fr: 'fr'
} as const

export type ItemStatus = (typeof ItemStatus)[keyof typeof ItemStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemStatus = {
  active: 'active',
  paused: 'paused',
  canceled: 'canceled',
  past_due: 'past_due',
  trialing: 'trialing'
} as const

export interface Item {
  created_at: string
  next_billed_at: string
  previously_billed_at: string
  price: Price
  product: Product
  quantity: number
  recurring: boolean
  status: ItemStatus
  trial_dates: BillingPeriod
  updated_at: string
}

export type InterviewType = (typeof InterviewType)[keyof typeof InterviewType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewType = {
  chat_only: 'chat_only',
  voice_only: 'voice_only',
  voice_and_video: 'voice_and_video',
  universal: 'universal'
} as const

export type InterviewTranscriptReplicaKind =
  (typeof InterviewTranscriptReplicaKind)[keyof typeof InterviewTranscriptReplicaKind]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewTranscriptReplicaKind = {
  candidate: 'candidate',
  interviewer: 'interviewer'
} as const

export type InterviewTransactionType =
  (typeof InterviewTransactionType)[keyof typeof InterviewTransactionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewTransactionType = {
  add: 'add',
  spend: 'spend'
} as const

export type InterviewStatus =
  (typeof InterviewStatus)[keyof typeof InterviewStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewStatus = {
  not_started: 'not_started',
  permissions_requested: 'permissions_requested',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
  incomplete: 'incomplete',
  failed: 'failed',
  service_error: 'service_error'
} as const

export type InterviewServiceProvider =
  (typeof InterviewServiceProvider)[keyof typeof InterviewServiceProvider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewServiceProvider = {
  anthropic: 'anthropic',
  openai: 'openai',
  elevenlabs: 'elevenlabs',
  heygen: 'heygen',
  google: 'google'
} as const

export interface InterviewResultsResource {
  aivy_messages_count?: number
  candidate_additional_contact?: string
  candidate_contact_email?: string
  candidate_contact_phone?: string
  candidate_country_code?: string
  candidate_country_name?: string
  candidate_name: string
  contacts: string[]
  created_at: string
  date: string
  deleted_at?: string
  duration_seconds: number
  grade?: string
  id: string
  is_finished: boolean
  is_marked: boolean
  meeting_mode?: VacancyMeetingMode
  overall_score: number
  position_title: string
  salary?: string
  status?: InterviewStatus
  updated_at: string
  user_device?: UserDevice
  user_id: string
  user_messages_count?: number
  user_profile_pic?: FileResource
  vacancy_id: string
  video_record_agreement: boolean
  video_url?: string
}

export interface InterviewResource {
  candidate_additional_contact?: string
  candidate_contact_email?: string
  candidate_contact_phone?: string
  candidate_country_code?: string
  candidate_country_name?: string
  candidate_name: string
  candidate_second_name: string
  company_id: string
  created_at: string
  deleted_at?: string
  duration_seconds?: number
  grade?: string
  id: string
  is_finished: boolean
  is_marked: boolean
  meeting_mode: VacancyMeetingMode
  overall_score?: number
  status?: InterviewStatus
  updated_at: string
  user_device?: UserDevice
  user_id: string
  vacancy_id: string
  video_record_agreement: boolean
  video_url?: string
}

export interface InterviewTransactionResource {
  amount: number
  company: CompanyResource
  company_id: string
  created_at: string
  description: string
  id: string
  interview?: InterviewResource
  interview_id: string
  reference_id?: string
  type: InterviewTransactionType
  vacancy?: VacancySimplifiedResource
  vacancy_id: string
}

export interface InterviewReplicaAvatar {
  blur_hash: string
  url: string
}

export type InterviewFinishInitiator =
  (typeof InterviewFinishInitiator)[keyof typeof InterviewFinishInitiator]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewFinishInitiator = {
  candidate: 'candidate',
  interviewer: 'interviewer',
  system: 'system'
} as const

export interface InterviewEvaluationStats {
  is_success: boolean
  total_score: number
}

export interface InterviewEvaluationResource {
  evaluation: InterviewEvaluationStats
  interview_id: string
}

export type InterviewCostReason =
  (typeof InterviewCostReason)[keyof typeof InterviewCostReason]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewCostReason = {
  dialog_input: 'dialog_input',
  dialog_output: 'dialog_output',
  dialog_cache_write: 'dialog_cache_write',
  dialog_cache_read: 'dialog_cache_read',
  evaluation_input: 'evaluation_input',
  evaluation_output: 'evaluation_output',
  tts: 'tts',
  stt: 'stt',
  video_avatar: 'video_avatar'
} as const

export interface InterviewCost {
  provider: InterviewServiceProvider
  reason: InterviewCostReason
  spent: number
}

export interface InterviewDetailsResource {
  aivy_messages_count?: number
  candidate_additional_contact?: string
  candidate_contact_email?: string
  candidate_contact_phone?: string
  candidate_country_code?: string
  candidate_country_name?: string
  candidate_name: string
  contacts: string[]
  costs: InterviewCost[]
  created_at: string
  date: string
  deleted_at?: string
  duration_seconds: number
  grade?: string
  id: string
  interview_transcript: InterviewTranscriptReplica[]
  is_finished: boolean
  is_marked: boolean
  link_to_video?: string
  meeting_mode?: VacancyMeetingMode
  overall_score: number
  overall_summary?: string
  position_title: string
  salary?: string
  skills_assessment: EvaluationSkill[]
  status?: InterviewStatus
  submitted_forms?: SubmittedForm[]
  total_score?: number
  updated_at: string
  user_device?: UserDevice
  user_id: string
  user_messages_count?: number
  user_profile_pic?: FileResource
  vacancy_id: string
  video_record_agreement: boolean
  video_url?: string
}

export interface InternalStatistics {
  complited_interviews: number
  countries: [string, number][]
  desktops: number
  failed_interviews: number
  form_complitions: number
  mobiles: number
  successful_candidates: number
}

export type InferenceType = (typeof InferenceType)[keyof typeof InferenceType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InferenceType = {
  openai_completion: 'openai_completion',
  anthropic_messages: 'anthropic_messages',
  vertex_ai_anthropic: 'vertex_ai_anthropic',
  azure_openai: 'azure_openai'
} as const

export interface InterviewTranscriptReplica {
  avatar: InterviewReplicaAvatar
  generated_by: InferenceType
  kind: InterviewTranscriptReplicaKind
  text: string
}

export type ImportVacancyFromTextResponseMeta = { [key: string]: unknown }

export type ImportVacancyFromTextResponseError = { [key: string]: unknown }

export interface ImportVacancyFromTextResponse {
  data: VacancyResource
  error: ImportVacancyFromTextResponseError
  meta: ImportVacancyFromTextResponseMeta
}

export interface ImportVacancyFromTextRequest {
  company_id?: string
  employer_id?: string
  ignore_warnings?: boolean
  text: string
  title?: string
  [key: string]: unknown
}

export interface ImageAttachment {
  blur_hash?: string
  file_size?: number
  height?: number
  mime_type?: string
  type?: string
  url: string
  width?: number
}

export type HttpResponseMeta = { [key: string]: unknown }

export type HttpResponseError = { [key: string]: unknown }

/**
 * HttpResponse(data: Any, meta: Optional[dict] = None, error: Optional[dict] = None)
 */
export interface HttpResponse {
  data: unknown
  error: HttpResponseError
  meta: HttpResponseMeta
}

export interface HeygenAvatarParams {
  avatar_id: string
}

export interface HTTPValidationError {
  detail?: ValidationError[]
}

export type GetVacancyUISettingsResponseMeta = { [key: string]: unknown }

export type GetVacancyUISettingsResponseError = { [key: string]: unknown }

export interface GetVacancyUISettingsResponse {
  data: VacancyUISettingsCollectionResource
  error: GetVacancyUISettingsResponseError
  meta: GetVacancyUISettingsResponseMeta
}

export type GetVacancyResponseMeta = { [key: string]: unknown }

export type GetVacancyResponseError = { [key: string]: unknown }

export interface GetVacancyResponse {
  data: VacancyResource
  error: GetVacancyResponseError
  meta: GetVacancyResponseMeta
}

export type GetVacancyInferenceSettingsResponseMeta = { [key: string]: unknown }

export type GetVacancyInferenceSettingsResponseError = {
  [key: string]: unknown
}

export interface GetVacancyInferenceSettingsResponse {
  data: VacancyInferenceSettingsResource
  error: GetVacancyInferenceSettingsResponseError
  meta: GetVacancyInferenceSettingsResponseMeta
}

export interface GetStatisticsResponse {
  data: SrcDomainsStatisticsSchemasGetStatisticsResponseData
}

export type GetReferenceResponseMeta = { [key: string]: unknown }

export type GetReferenceResponseError = { [key: string]: unknown }

export interface GetReferenceResponse {
  data: ReferenceResource
  error: GetReferenceResponseError
  meta: GetReferenceResponseMeta
}

export type GetPushDeliveryResponseMeta = { [key: string]: unknown }

export type GetPushDeliveryResponseError = { [key: string]: unknown }

export interface GetPushDeliveryResponse {
  data: PushDeliveryResource
  error: GetPushDeliveryResponseError
  meta: GetPushDeliveryResponseMeta
}

export type GetProfileResponseMeta = { [key: string]: unknown }

export type GetProfileResponseError = { [key: string]: unknown }

export interface GetProfileResponse {
  data: ProfileResource
  error: GetProfileResponseError
  meta: GetProfileResponseMeta
}

export interface GetNotificationEmailResponse {
  data: NotificationEmailResource
}

export type GetListFilesResponseMeta = { [key: string]: unknown }

export type GetListFilesResponseError = { [key: string]: unknown }

export interface GetListFilesResponse {
  data: FileResource[]
  error: GetListFilesResponseError
  meta: GetListFilesResponseMeta
}

export type GetInterviewTransactionResponseMeta = { [key: string]: unknown }

export type GetInterviewTransactionResponseError = { [key: string]: unknown }

export interface GetInterviewTransactionResponse {
  data: InterviewTransactionResource
  error: GetInterviewTransactionResponseError
  meta: GetInterviewTransactionResponseMeta
}

export interface GetInterviewStateResponse {
  data: SrcDomainsInterviewSchemasGetInterviewStateResponseData
}

export interface GetInterviewResponse {
  data: InterviewResource
}

export type GetInterviewEvaluationResponseMeta = { [key: string]: unknown }

export type GetInterviewEvaluationResponseError = { [key: string]: unknown }

export interface GetInterviewEvaluationResponse {
  data: InterviewEvaluationResource
  error: GetInterviewEvaluationResponseError
  meta: GetInterviewEvaluationResponseMeta
}

export interface GetInterviewDetailsResponse {
  data: InterviewDetailsResource
}

export interface GetHeygenCreateTokenResponse {
  token: string
}

export interface GetHeygenConfigResponse {
  avatar_id: string
  token: string
  voice_id: string
  [key: string]: unknown
}

export type GetFileResponseMeta = { [key: string]: unknown }

export type GetFileResponseError = { [key: string]: unknown }

export interface GetFileResponse {
  data: FileResource
  error: GetFileResponseError
  meta: GetFileResponseMeta
}

export type GetExpertResponseMeta = { [key: string]: unknown }

export type GetExpertResponseError = { [key: string]: unknown }

export interface GetExpertResponse {
  data: ExpertResource
  error: GetExpertResponseError
  meta: GetExpertResponseMeta
}

export type GetEvaluationTemplateResponseMeta = { [key: string]: unknown }

export type GetEvaluationTemplateResponseError = { [key: string]: unknown }

export interface GetEvaluationTemplateResponse {
  data: EvaluationTemplateResource
  error: GetEvaluationTemplateResponseError
  meta: GetEvaluationTemplateResponseMeta
}

export type GetCompanyResponseV2Meta = { [key: string]: unknown }

export type GetCompanyResponseV2Error = { [key: string]: unknown }

export interface GetCompanyResponseV2 {
  data: CompanyResourceV2
  error: GetCompanyResponseV2Error
  meta: GetCompanyResponseV2Meta
}

export type GetCompanyResponseMeta = { [key: string]: unknown }

export type GetCompanyResponseError = { [key: string]: unknown }

export interface GetCompanyResponse {
  data: CompanyResource
  error: GetCompanyResponseError
  meta: GetCompanyResponseMeta
}

export type GetCheckoutResponseMeta = { [key: string]: unknown }

export type GetCheckoutResponseError = { [key: string]: unknown }

export interface GetCheckoutResponse {
  data: CheckoutResource
  error: GetCheckoutResponseError
  meta: GetCheckoutResponseMeta
}

export interface GenerateWelcomeBackRequest {
  user_id: UserId
  vacancy_id: string
}

export interface GenerateInterviewStreamRequest {
  user_id: UserId
  user_msg: string
  vacancy_id: string
}

export type Gender = (typeof Gender)[keyof typeof Gender]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  male: 'male',
  female: 'female'
} as const

export type FormComponentType =
  (typeof FormComponentType)[keyof typeof FormComponentType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormComponentType = {
  input: 'input',
  select_buttons: 'select_buttons',
  select_select: 'select_select',
  checkbox: 'checkbox'
} as const

export type FormComponentDataType =
  (typeof FormComponentDataType)[keyof typeof FormComponentDataType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormComponentDataType = {
  number: 'number',
  string: 'string',
  boolean: 'boolean'
} as const

export interface FormComponent {
  data_type: FormComponentDataType
  description?: string
  id: string
  label?: string
  placeholder?: string
  select_values?: string[]
  type: FormComponentType
  ui_validations?: ValidationRule[]
  validations?: ValidationRule[]
}

export interface FormSchema {
  components?: FormComponent[]
  description?: string
  header: string
  id: string
}

export interface FirebaseLoginRequest {
  token: string
}

export type FileKind = (typeof FileKind)[keyof typeof FileKind]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileKind = {
  unknown: 'unknown',
  expert_profile_pic: 'expert_profile_pic',
  expert_profile_photo: 'expert_profile_photo',
  expert_profile_video: 'expert_profile_video',
  user_profile_pic: 'user_profile_pic',
  artific_share_video: 'artific_share_video',
  post_image: 'post_image',
  post_video: 'post_video',
  voice_sample: 'voice_sample',
  video_sample: 'video_sample',
  photo_sample: 'photo_sample',
  text_llm_data: 'text_llm_data',
  verification_document: 'verification_document',
  image_generation: 'image_generation',
  background_pic: 'background_pic',
  interview_candidate_pic: 'interview_candidate_pic',
  vacancy_slide_pic: 'vacancy_slide_pic',
  vacancy_company_pic: 'vacancy_company_pic'
} as const

export interface FileResource {
  blur_hash?: string
  id: string
  kind: FileKind
  link: string
  mime_type: string
}

export interface ExternalStatistics {
  call_finished: number
  call_started: number
  exit_clicked: number
  traffic: number
}

export type ExpertResourceExtendedDataGenerationParams = {
  [key: string]: BaseGenerationParams
}

export interface ExpertResourceExtendedData {
  avatar: ArtificAvatarParams
  created_at: string
  elevenlabs_voice_id?: string
  generation_params: ExpertResourceExtendedDataGenerationParams
  inference_type: InferenceType
  updated_at: string
  voice: ArtificVoiceParams
}

export interface ExpertResource {
  avatar_type: AvatarType
  extended_data?: ExpertResourceExtendedData
  full_description?: string
  full_name: string
  gender: Gender
  id: string
  is_enabled: boolean
  language: LanguageCode
  profile_pic?: FileResource
}

export type EvaluationSkillScore = number | string

export interface EvaluationSkill {
  description: string
  max_score: number
  score: EvaluationSkillScore
  title: string
}

export type EvaluationCriterionType =
  (typeof EvaluationCriterionType)[keyof typeof EvaluationCriterionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EvaluationCriterionType = {
  text: 'text',
  integer: 'integer',
  boolean: 'boolean'
} as const

export interface EvaluationCriterion {
  description: string
  title: string
  type: EvaluationCriterionType
}

export interface EvaluationTemplateResource {
  created_at: string
  evaluation_criterions: EvaluationCriterion[]
  id: string
  system_prompt_instructions: string[]
  updated_at: string
  user_prompt_instructions: string[]
  vacancy_id: string
}

export interface EvaluateInterviewRequest {
  force?: boolean
  initiator: InterviewFinishInitiator
}

export type ErrorModelDetailAnyOf = { [key: string]: string }

export type ErrorModelDetail = string | ErrorModelDetailAnyOf

export interface ErrorModel {
  detail: ErrorModelDetail
}

export type EmployerResponseMeta = { [key: string]: unknown }

export type EmployerResponseError = { [key: string]: unknown }

export interface EmployerResource {
  company_id: string
  id: string
  is_default: boolean
  title: string
}

export interface EmployerResponse {
  data: EmployerResource
  error: EmployerResponseError
  meta: EmployerResponseMeta
}

export interface ElevenLabsVoiceParams {
  language?: LanguageCode
  similarity_boost: number
  stability: number
  style: number
  use_speaker_boost: boolean
  voice_id: string
  voice_velocity: number
}

export interface DurationTickRequest {
  tick_seconds: number
}

export interface DeleteUserRequest {
  reason?: string
}

export interface CustomData {
  active_subscription_amount?: string
  is_aivy_product?: boolean
}

export interface CreateProfileRequest {
  contact_email?: string
  contact_phone?: string
  is_onboarding_passed?: boolean
  name: string
  onboarding_data?: OnboardingData
  second_name?: string
}

export interface CreateNotificationEmailRequest {
  company_id?: string
  email: string
  enabled?: boolean
  notification_types?: NotificationTypes
  title?: string
}

export interface CreateInterviewTransactionRequest {
  amount: number
  company_id: string
  description: string
  reference_id?: string
  type: InterviewTransactionType
}

export interface CreateInterviewRequest {
  user_additional_contact?: string
  user_contact_email?: string
  user_contact_phone?: string
  user_device?: UserDevice
  user_name: string
  user_second_name: string
  vacancy_id: string
}

export interface CreateEvaluationTemplateRequest {
  system_prompt_instructions: string[]
  user_prompt_instructions: string[]
  vacancy_id: string
}

export interface CreateEmployerRequest {
  company_id?: string
  title: string
}

export interface CreateCompanyRequest {
  description: string
  name: string
}

export interface CreateCheckoutRequest {
  checkout_item_id: string
  quantity: number
  user_id: UserId
  [key: string]: unknown
}

export type CreateArtificRequestGenerationParams = {
  [key: string]: BaseGenerationParams
}

export interface CreateArtificRequest {
  avatar?: ArtificAvatarParams
  avatar_type?: AvatarType
  elevenlabs_voice_id?: string
  full_description?: string
  full_name: string
  gender: string
  generation_params: CreateArtificRequestGenerationParams
  inference_type?: InferenceType
  is_enabled?: boolean
  profile_pic_file_id: string
  voice?: ArtificVoiceParams
}

export interface CompanyResourceV2 {
  balance: CompanyBalance
  created_at: string
  description: string
  id: string
  name: string
  updated_at: string
}

export interface CompanyResource {
  active_subscription_amount: number
  created_at: string
  current_balance: number
  description: string
  id: string
  name: string
  updated_at: string
}

export type CompanyBalanceUsed = { [key: string]: number }

export type CompanyBalancePurchased = { [key: string]: number }

export interface CompanyBalance {
  purchased: CompanyBalancePurchased
  used: CompanyBalanceUsed
}

export interface CheckoutItemResource {
  credits: number
  id: string
  price: number
  title: string
  [key: string]: unknown
}

export interface CheckoutResource {
  checkout_item: CheckoutItemResource
  created_at: string
  id: string
  quantity: number
  status: string
  [key: string]: unknown
}

export interface ButtonActionUrl {
  type?: string
  url: string
}

export interface ButtonActionOpenArtific {
  artific_id: string
  type?: string
}

export interface BodyVerifyVerifyApiV1AuthVerifyPost {
  token: string
}

export interface BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost {
  email: string
}

export interface BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost {
  file: Blob
}

export interface BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch {
  external_id?: string
  file?: Blob
}

export interface BodySaveFileApiV1FilesPost {
  alias?: string
  entity_id?: string
  file: Blob
  kind: FileKind
}

export interface BodyResetResetPasswordApiV1AuthResetPasswordPost {
  password: string
  token: string
}

export interface BodyResetForgotPasswordApiV1AuthForgotPasswordPost {
  email: string
}

export interface BodyLoginApiV1AuthLoginPost {
  client_id?: string
  client_secret?: string
  /** @pattern password */
  grant_type?: string
  otp_token?: string
  password: string
  scope?: string
  username: string
}

export interface BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost {
  external_id: string
  file: Blob
}

export interface BillingPeriod {
  ends_at: string
  starts_at: string
}

export interface BillingDetails {
  additional_information?: string
  enable_checkout?: boolean
  purchase_order_number?: string
}

export type BillingCycleInterval =
  (typeof BillingCycleInterval)[keyof typeof BillingCycleInterval]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillingCycleInterval = {
  month: 'month',
  year: 'year',
  day: 'day',
  week: 'week'
} as const

export interface BillingCycle {
  frequency: number
  interval: BillingCycleInterval
}

export interface BearerResponse {
  access_token: string
  token_type: string
}

export interface BatchInterviewRequest {
  /**
   * @minItems 1
   * @maxItems 20
   */
  ids?: string[]
}

export interface BaseGenerationParams {
  max_tokens?: number
  model: string
  temperature: number
  top_p?: number
}

export type AvatarType = (typeof AvatarType)[keyof typeof AvatarType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvatarType = {
  audio: 'audio',
  video: 'video'
} as const

export type AuthType = (typeof AuthType)[keyof typeof AuthType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthType = {
  fusion: 'fusion',
  local: 'local'
} as const

export interface ArtificVoiceParams {
  generator: string
  parameters: ElevenLabsVoiceParams
}

export interface ArtificAvatarParams {
  generator: string
  parameters: HeygenAvatarParams
}

export type ArtificAttachmentButtonAction =
  | ButtonActionUrl
  | ButtonActionOpenArtific

export interface ArtificAttachment {
  artific_id: string
  button_action: ArtificAttachmentButtonAction
  button_title: string
  description: string
  name: string
  profile_picture: FileResource
  rating: number
  reviews_count: number
  type: string
}

export type AppsumoWebookNotificationEvent =
  (typeof AppsumoWebookNotificationEvent)[keyof typeof AppsumoWebookNotificationEvent]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppsumoWebookNotificationEvent = {
  purchase: 'purchase',
  activate: 'activate',
  upgrade: 'upgrade',
  downgrade: 'downgrade',
  migrate: 'migrate',
  deactivate: 'deactivate'
} as const

export interface AppsumoWebookNotification {
  created_at: number
  event: AppsumoWebookNotificationEvent
  event_timestamp: number
  extra?: LicenseExtra
  license_key: string
  license_status: LicenseStatus
  parent_license_key?: string
  partner_plan_name?: string
  prev_license_key?: string
  test?: boolean
  tier?: number
  unit_quantity?: number
}

export type AppsumoResourceAddonsItem = { [key: string]: unknown }

export interface AppsumoResource {
  addons: AppsumoResourceAddonsItem[]
  partner_plan_name: string
  status: string
  tier: number
}

export interface AppendCostRequest {
  provider: InterviewServiceProvider
  reason: InterviewCostReason
  spent: number
}

export interface AivyVideoRecordAgreement {
  agreement: boolean
  type?: string
}

export interface AivyInterviewSwitchLanguageAttachment {
  language_code: string
  type?: string
}

export type AivyInterviewStatus =
  (typeof AivyInterviewStatus)[keyof typeof AivyInterviewStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AivyInterviewStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1
} as const

export interface AivyInterviewStatusAttachment {
  interview_status: AivyInterviewStatus
  type?: string
}

export interface AivyGenerationIdAttachment {
  generation_id: string
  type?: string
}

export interface AddUsersToCompanyRequest {
  user_ids: string[]
}

export interface AddReferenceRequest {
  alias: string
  description?: string
  sort?: number
  title: string
  value?: string
}
